import { render } from "./ManageNotifications.vue?vue&type=template&id=ada921de&scoped=true"
import script from "./ManageNotifications.vue?vue&type=script&lang=js"
export * from "./ManageNotifications.vue?vue&type=script&lang=js"

import "./ManageNotifications.vue?vue&type=style&index=0&id=ada921de&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ada921de"]])

export default __exports__